import { createContext } from "react";

export interface IUnsentMessagesGuardContext {
  /** Reported by the open chat whenever its unsent count changes. */
  setHasUnsentMessages: (hasUnsentMessages: boolean) => void;
}

export const UnsentMessagesGuardContext =
  createContext<IUnsentMessagesGuardContext>({
    setHasUnsentMessages: () => {},
  });
